import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent {
  reason: string;
  orderNo: string;
  showOrdersLink: boolean = false;
  constructor(private route: ActivatedRoute) {}

ngOnInit() {
  this.route.queryParams.subscribe(params => {
    this.reason = params['reason'];
      this.orderNo = params['orderNo'];
      this.showOrdersLink = !!this.orderNo; 
    console.log('Redirect Reason:', this.reason, 'Order No:', this.orderNo);
  });
}

}
